import type { GetOrganizationDevicesResponse } from "@somewear/api";
import { createActionSet } from "@somewear/model";

export const organizationDeviceActions = {
	getDevices: createActionSet<void, GetOrganizationDevicesResponse.AsObject>(
		"organization/devices/get"
	),
};
